import { Component, EventEmitter, Output, Input, OnInit, OnDestroy } from '@angular/core';
import { ConfirmOutput } from '../../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../../shared/enums/CPDialogResult';
import { CRUDActions } from '../../../shared/enums/CRUDActions';
import { CommonFunctions } from '../../../shared/static/common-functions';
import { BaseMessageInfo } from '../../../shared/models/BaseMessageInfo';
import { GlobalsService } from '../../../shared/services/globals.service';

import { DQOIReferenceData } from '@app/cp/shared/models/DQOIReferenceData';
import { BaseDQOIComponent } from '@app/cp/shared/base-components/base-dqoi.component';
import { GItem } from '../../../shared/models/GItem';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { DomainService } from '../../../shared/services/domain.service';
import * as _ from 'lodash';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BaseAppMComponent } from '../../../shared/base-components/base-app-m.component';
import { DQOIReferenceDataQuery } from '../../../dqoi/state/dqoi-reference-data.query';
import { CommonValues } from '../../../shared/static/CommonValues';
import { BillingCodeBus } from '../../../shared/models/BillingCodeBus';
import { DomainHeaderBus } from '../../models/DomainHeaderBus';
import { DomainItems } from '../../enums/DomainItems';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";
import { CmProAuthService } from '@app/core/services';
import { UsersBus } from '../../models/UsersBus.model';

@Component({
    selector: 'billing-codes-dialog',
    templateUrl: './billing-codes-dialog.component.html',
    styleUrls: ['./billing-codes-dialog.component.scss'],
    standalone: false
})
export class BillingCodesDialogComponent extends BaseAppMComponent<BillingCodeBus, DomainService, null, null> implements OnInit, OnDestroy {

    appCode: string = null;
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, public svc_data: DomainService, qry_rd: DQOIReferenceDataQuery,  private authService: CmProAuthService) {
        super(globals, featureFlagService, qry_rd);

        this.appCode = "Billing Code"
    }
    public editForm: UntypedFormGroup
    get referenceData(): DQOIReferenceData {
        return BaseDQOIComponent._referenceData;
    }

   billingCodes: BillingCodeBus[]

    public filterSettings: DropDownFilterSettings = {
        caseSensitive: false,
        operator: 'contains'
    };

    active: boolean = false;
    data: any;
    selectedBillingCodeInfo: BillingCodeBus;
    action1: CRUDActions;

    hideWhenDiscountCodeSelected: boolean;
    incomeLabelText: string = "Income";

    billingTypes: DomainHeaderBus;
    accounts: DomainHeaderBus;
    coas: DomainHeaderBus;
    code: string;
    @Input() title: string;
    @Input() message: string;
    @Output() confirmation: EventEmitter<ConfirmOutput> = new EventEmitter<ConfirmOutput>();
    @Input() sublings: GItem[] = [];

    override ngOnInit() {
        super.ngOnInit();
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.readOnly = user.appClaims.EditBillingCodes !== true;
            }
        });
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        this.authService.unsubscribeToLoginEvents();
    }

    hide() {
        this.active = false;
        this.data = null;
        this.title = null;
        this.message = null;
        this.action1 = CRUDActions.None;

    }
    ok() {
        this.trySave();
    }

    trySave() {
        let billingCode = this.editForm.value.billingCode;
        let billingCodeId: any = this.editForm.value.billingCodeId;

        let doesBillingCodeExist: any = this.billingCodes.find(s => s.billingCode === billingCode);

        if (!CommonFunctions.hasGuidValue(billingCodeId) && CommonFunctions.hasStringValue(billingCode) && CommonFunctions.hasValue(doesBillingCodeExist)) {
            this.cnfShow("The billing code already exists.", CRUDActions.None, null, "Duplicate Billing Code", "DUP_BILLINGCODE", false);
            this.clear();
        }
        else {

            if (CommonFunctions.hasGuidValue(billingCodeId)) {
                this.cnfShow("You are about to update an existing billing code.  Press OK to continue or Cancel to abort?", CRUDActions.Create, null, "Update", "EDIT_EXISTING");
            }
            else {
                this.save();
            }
        }
    }

    createNew(newObj: BillingCodeBus) {
        newObj = new BillingCodeBus();
        newObj.costMultiplier = 1;
        console.log(newObj);
        return newObj;
    }

    confirmCustom(data: ConfirmOutput) {
        if (data.dialogResult === CPDialogResult.ok && data.code === "EDIT_EXISTING") {
            this.save();
        }
    }

    save() {
        let user = this.globals.user;

        let busObj: BillingCodeBus = new BillingCodeBus();

        busObj.setFromForm(this.editForm.value);
        busObj.setCommon(user.userid, new Date(Date.now()));
        busObj.setBeforeSave();

        if (!busObj.billingCodeId) { busObj.billingCodeId = CommonValues.Guid_Empty }

        this.svc_data.saveBillingCode(busObj).subscribe((info: BaseMessageInfo) => {
            if (!info.saveError) {
                this.saveSuccess();
                this.hide();
            }
            else {
                this.saveError(info.message);
            }

        },
            err => { this.CallFailed(err) }
        );

    }

    CallFailed(err) {

        this.saveError(err)

    }
    cancel() {
        let result: ConfirmOutput = { action: this.action1, dialogResult: CPDialogResult.cancel, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    close() {
        let result: ConfirmOutput = { action: this.action1, dialogResult: CPDialogResult.close, data: null, code: this.code }
        this.confirmation.emit(result);
        this.hide();
    }
    public show(id?: any) {
        this.createForm();
        this.active = true;

        this.svc_data.getAllBillingCodes().subscribe(
            (data: BaseMessageInfo) => {
                if (CommonFunctions.hasValue(data.primaryReturn)) {
                    this.billingCodes = _.cloneDeep(data.primaryReturn);
                }
            });

        this.editForm.patchValue({
            multiplier: 1
        });

        this.svc_data.GetDomainData(DomainItems.BillingTypes.toString()).subscribe(data => {
            this.billingTypes = _.cloneDeep(data);
        });

        this.svc_data.GetDomainData(DomainItems.COAs.toString()).subscribe(data => {
            this.coas = _.cloneDeep(data);
        });

        this.svc_data.getAccountsDomain().subscribe(data => {
            this.accounts = _.cloneDeep(data);
        });
    }

    public billingCodeSelected(selectedValue: any): void {
        if (selectedValue) {
            let dataObject: BillingCodeBus = this.billingCodes.find(x => x.billingCodeId === selectedValue.billingCodeId);
            this.setFormData(dataObject);
        }
        else {
            this.clear();
        }
    }

    public billingTypeSelected(selectedValue: any): void {
        if (selectedValue) {
            this.hideWhenDiscountCodeSelected = selectedValue.id === "b31dfe4e-9b88-4b6e-b4d3-d04a491c153f" ? true : false;
            this.incomeLabelText = selectedValue.id === "b31dfe4e-9b88-4b6e-b4d3-d04a491c153f" ? "Expense" : "Income";
        }
    }

    public setFormData(formData: BillingCodeBus) {
        if (CommonFunctions.hasValue(formData)) {
            this.editForm.patchValue({
                billingTypeId: formData.billingTypeId,
                incomeAccountId: formData.incomeAccountId,
                costDebitAccountId: formData.costDebitAccountId,
                costCreditAccountId: formData.costCreditAccountId,
                billCoaid: formData.billCoaid,
                invoiceCoaid: formData.invoiceCoaid,
                isActive: formData.isActive,
                billingDesc: formData.billingDesc,
                costMultiplier: formData.costMultiplier,
                rate: formData.rate,
                cost: formData.cost,
                billingCode: formData.billingCode
            });
        }
        else {
            console.log("No data to map")
        }

    }

    createForm() {
        this.editForm = new UntypedFormGroup({
            'billingCodeId': new UntypedFormControl(),
            'billingCode': new UntypedFormControl('', Validators.required),
            'billingTypeId': new UntypedFormControl(),
            'rate': new UntypedFormControl(),
            'cost': new UntypedFormControl(),
            'costMultiplier': new UntypedFormControl(),
            'billingDesc': new UntypedFormControl(),
            'incomeAccountId': new UntypedFormControl(),
            'costDebitAccountId': new UntypedFormControl(),
            'costCreditAccountId': new UntypedFormControl(),
            'billCoaid': new UntypedFormControl(),
            'invoiceCoaid': new UntypedFormControl(),
            'isActive': new UntypedFormControl(),
            });}
}

